/** @type {import("@chakra-ui/react").ComponentStyleConfig} */
export const BUTTON_THEME = {
  variants: {},
  baseStyle: {
    borderRadius: "4px",
  },
};
